import styled, { css } from 'styled-components';

export const CardHorizontalScroll = styled.div`
  overflow-x: hidden;
  scroll-behavior: smooth;
  display: flex;
  overflow-x: hidden;
  position: relative;

  @media (max-width: 720px) {
    display: flex;
    margin-top: 10px;
    padding-bottom: 16px;
    overflow-x: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  & .scrollStyle ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const RelativeContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 85%;
  margin: auto;

  @media (max-width: 720px) {
    max-width: 100%;
    overflow-y: scroll;
  }
`;

export const BestSeller = styled.div`
  background: linear-gradient(
    to bottom,
    ${(props) => props.sectionBgColorStart},
    ${(props) => props.sectionBgColorEnd}
  );
  display: grid;
  align-items: center;
  grid-template-columns: 100%;
  position: relative;
  padding: 20px 0 0;
  margin: 20px 0 0;

  @media (max-width: 720px) {
    margin-top: 0;
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const Controller = styled.div`
  & .rightcontrollerCards {
    display: flex;
    justify-content: center;
    position: absolute;
    right: 0;
    width: 40px;
    overflow-x: hidden;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;

    @media (max-width: 720px) {
      display: none;
    }

    img {
      width: 20px;
      transform: rotate(270deg);
    }
  }

  & .leftcontrollerCards {
    position: absolute;
    display: flex;
    justify-content: center;
    left: 30%;
    width: 40px;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    z-index: 9;

    @media (max-width: 720px) {
      display: none;
    }

    img {
      width: 20px;
      transform: rotate(90deg);
    }
  }
`;

export const LeftController = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  left: ${(props) =>
    props.shiftArrow
      ? '3%'
      : props.babyTrustUI
        ? '48%'
        : props.allReviews
          ? '480px'
          : props.autoHeight
            ? '-34px'
            : props.bogo
              ? '0'
              : '-50px'};
  width: 40px;
  height: ${(props) => (props.autoHeight ? 'auto' : '100%')};
  cursor: pointer;
  z-index: 9;
  transition: all 0.3s ease;
  align-items: center;

  @media (max-width: 720px) {
    display: none;
  }

  img {
    width: 20px;
    transform: rotate(90deg);
    height: 20px;
  }

  ${(props) =>
    props.showMobileArrows &&
    css`
      left: ${(props) =>
        props.autoHeight ? '-34px' : props.bogo ? '0' : '10px'};
      width: 30px;
      background: white;
      opacity: 0.8;
      border-radius: 50%;
      height: ${(props) => (props.autoHeight ? 'auto' : '32px')};
      @media (max-width: 720px) {
        display: flex;
      }
    `}
`;

export const RightController = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  right: ${(props) =>
    props.shiftArrow
      ? '50px'
      : props.babyTrustUI
        ? '110px'
        : props.allReviews
          ? '-40px'
          : props.autoHeight
            ? '-34px'
            : props.bogo
              ? '0'
              : '-50px'};
  width: 40px;
  overflow-x: hidden;
  height: ${(props) => (props.autoHeight ? 'auto' : '100%')};
  cursor: pointer;
  z-index: 9;
  align-items: center;

  @media (max-width: 720px) {
    display: none;
  }

  img {
    width: 20px;
    transform: rotate(270deg);
    height: 20px;
  }

  ${(props) =>
    props.showMobileArrows &&
    css`
      right: ${(props) =>
        props.autoHeight ? '-34px' : props.bogo ? '0' : '10px'};
      width: 30px;
      background: white;
      opacity: 0.8;
      border-radius: 50%;
      height: ${(props) => (props.autoHeight ? 'auto' : '32px')};
      @media (max-width: 720px) {
        display: flex;
      }
    `}
`;
